import React from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie"; // Importing react-lottie
import animdata from "assets/lottie/colab/colab_05.json";

const CallToAction = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/contact");
  };

  // Lottie animation options
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animdata
  };

  return (
    <div className="flex flex-col justify-center items-center w-full mt-16 py-12 px-6 bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-center shadow-lg">
        <div className="flex flex-col justify-center items-center w-full h-[200px] overflow-hidden">
            <div className="w-full md:w-1/2 max-w-sm mb-0">
                <Lottie options={defaultOptions} isClickToPauseDisabled={true} style={{
                    cursor:"default"
                }} />
            </div>
        </div>
        

        <h2 className="mt-0 text-4xl font-title font-extrabold mb-6 uppercase tracking-wide">
            Got an Awesome Idea? Let’s Make it Real!
        </h2>
        <p className="text-lg font-body leading-relaxed mb-8">
            We’re all about turning crazy ideas into jaw-dropping animations. Ready to team up? Don’t be shy—hit that button!
        </p>

        <button
            onClick={handleButtonClick}
            className="hover:scale-110 text-xl px-8 py-4 bg-yellow-400 text-indigo-900 font-title font-semibold rounded-full shadow hover:tracking-widest transition-all duration-300"
        >
            Let’s Chat!
        </button>
    </div>
  );
};

export default CallToAction;
